import React from 'react';
import { cn } from '../../utils/cn'; // We'll create this utility
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-black text-white hover:bg-gray-800 shadow-sm hover:shadow-md',
    secondary: 'bg-white text-black border border-gray-200 hover:bg-gray-50 hover:border-gray-300 shadow-sm',
    outline: 'bg-transparent text-black border border-gray-200 hover:border-black',
    ghost: 'bg-transparent text-gray-600 hover:text-black hover:bg-gray-100'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className || ''}`} {...props} data-id="element-248">
      {children}
    </button>;
}